var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "navbar navbar--border navbar--height navbar--mobile",
      class: [{ "injectable-mobile": _vm.isInjectable }],
      attrs: { role: "navigation", "aria-label": "main navigation" }
    },
    [
      _c(
        "ul",
        { staticClass: "navbar-list--inline" },
        [
          !_vm.isCheckout && !_vm.isInjectable
            ? [
                _c("div", { staticClass: "navbar-item" }, [
                  _vm.displayBackButton()
                    ? _c(
                        "div",
                        { staticClass: "back-button-wrapper" },
                        [
                          _c("BaseBackButton", {
                            attrs: {
                              useTitle: true,
                              title: "Back",
                              click: _vm.handleBackButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.main()
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "navigation-title",
                          class: _vm.centerNavigationStyle
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "logo-container",
                              attrs: { to: "/" }
                            },
                            [
                              _c("img", {
                                staticClass: "logo",
                                attrs: {
                                  alt: "store logo image",
                                  src: require("../../assets/store-logo.png")
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("navigation-location-mobile")
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.main()
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "navigation-title",
                          class: _vm.centerNavigationStyle
                        },
                        [
                          _vm.hasTitle()
                            ? _c(
                                "div",
                                {
                                  staticClass: "title-container",
                                  class: _vm.setResponsiveTitle
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.titleName) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("account-menu")
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isInjectable
            ? [
                !_vm.order
                  ? _c("div", { staticClass: "columns is-mobile full-width" }, [
                      _c("div", { staticClass: "column is-8" }, [
                        _vm.customer
                          ? _c(
                              "p",
                              [
                                _vm._v("\n                            Hi "),
                                _c(
                                  "span",
                                  { staticClass: "store-navigation-color" },
                                  [_vm._v(_vm._s(_vm.customer.firstName))]
                                ),
                                _vm._v("!"),
                                _c("br"),
                                _vm._v(" "),
                                _vm.loyaltyPoints
                                  ? [
                                      _vm._v("You have "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "store-navigation-color"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.loyaltyPoints) +
                                              " " +
                                              _vm._s(
                                                _vm.$appConstants.pointsName
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "column is-4 is-narrow" },
                        [
                          _c(
                            "navigation-route",
                            {
                              attrs: {
                                target: "_parent",
                                link:
                                  _vm.baseURL +
                                  (_vm.itemCount ? "checkout" : ""),
                                isVueRoute: false,
                                classes:
                                  "button is-primary is-rounded nav-btn is-pulled-right"
                              }
                            },
                            [
                              _vm._v(
                                "\n                               " +
                                  _vm._s(
                                    _vm.itemCount
                                      ? "Checkout"
                                      : "Start your order"
                                  ) +
                                  "\n                                "
                              ),
                              _c(
                                "span",
                                { staticClass: "checkout-arrow" },
                                [
                                  !_vm.itemCount
                                    ? _c("BaseIcon", {
                                        attrs: {
                                          icon: "forwardArrow",
                                          size: "sm"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.itemCount
                                ? _c(
                                    "div",
                                    { staticClass: "item-count-background" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "item-count" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.itemCount) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _c(
                      "div",
                      { staticClass: "header-tracker" },
                      [
                        _c("order-tracker", {
                          attrs: {
                            orderLocation: _vm.location,
                            order: _vm.order,
                            isStreamLined: true
                          }
                        })
                      ],
                      1
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab0e9550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab0e9550","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationMobile.vue
// module id = null
// module chunks = 